// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/Assets/Images/bgWallpaper.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KbSelection{
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: relative;
}

.proceedBtn{
    display: flex;
    justify-content: center;
    align-items: center;

}

select {
    z-index: 10;
}
select option{
    background-color: white;
    color: black;
    padding: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Core/Components/kbSelection/KbSelection.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mDAAwD;IACxD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".KbSelection{\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n    flex-direction: column;\n    background: url(\"/public/Assets/Images/bgWallpaper.svg\");\n    position: relative;\n}\n\n.proceedBtn{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\nselect {\n    z-index: 10;\n}\nselect option{\n    background-color: white;\n    color: black;\n    padding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
